import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Dropdown, Menu } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { downloadDocument } from "../../../store/actions/download/index";

const DownloadBtn = props => {
  const {
    documentId,
    isEinvoice,
    fileName,
    setCurrentIndex,
    index
  } = props;
  const dispatch = useDispatch();

  // BEGIN REDUX STATE
  const info = useSelector(state => state.detailsDocument.info);
  // END REDUX STATE

  const downloadDocumentLocal = outputFormat => {

    // setto l'indice corrente come l'indice della riga della dashboard renderizzata dentro un ciclo
  
    setCurrentIndex(index);
    
    // rimuovo l'eventuale estensione del file

    const fileNameVar = fileName
      ? fileName
      : info &&
        info.details &&
        info.details.fileNameVar &&
        info.details.fileNameVar;
    const defaultfileNameVar = fileNameVar.substring(0,
      fileNameVar?.indexOf(fileNameVar.split(".").pop()) - 1);

    dispatch(downloadDocument(
      documentId ? documentId : info.details.documentId,
      isEinvoice ? defaultfileNameVar : info.details.fileNameVar,
      isEinvoice ? isEinvoice : info.details ? info.details.einvoice : false,
      outputFormat
    ));
  };

  return isEinvoice || (info.details && info.details.einvoice) ? (
    <div
      style={{
        cursor: "pointer",
        display: "inline-block",
        paddingRight: "10px"
      }}
    >
      <Dropdown
        placement="topLeft"
        overlayStyle={{ zIndex: "99999999999", padding: 0 }}
        overlay={
          <Menu>
            <Menu.Item key="0">
              <div
                className="gs-documents-download"
                onClick={e => downloadDocumentLocal("ASSOSW")}
              >
                SCARICA PDF
              </div>
            </Menu.Item>
            <Menu.Item key="1">
              <div
                className="gs-documents-download"
                onClick={e => downloadDocumentLocal("XML")}
              >
                SCARICA XML
              </div>
            </Menu.Item>
          </Menu>
        }
      >
        <div onClick={e => e.preventDefault()}>
          <FontAwesomeIcon
            icon={["far", "arrow-to-bottom"]}
            style={{ color: "#0090d1", fontSize: "16px" }}
          />
          <span style={{ marginLeft: "8px" }}> Download </span>
        </div>
      </Dropdown>
    </div>
  ) : (
    <div
      className="gs-documents-download"
      style={{
        cursor: "pointer",
        display: "inline-block",
        paddingRight: "10px"
      }}
      onClick={() => {
        downloadDocumentLocal(null);
      }}
    >
      <FontAwesomeIcon
        icon={["far", "arrow-to-bottom"]}
        style={{
          color: "#0090d1",
          fontSize: "16px",
          cursor: "pointer"
        }}
      />
      <span style={{ marginLeft: "8px" }}> Download </span>
    </div>
  );
};

export default DownloadBtn;
